import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Network } from "lucide-react";

const serviceData = {
  id: "reseau",
  title: "Réseau informatique",
  description: "Installation et maintenance de réseaux informatiques professionnels",
  icon: Network,
  image: "/reseau.jpg", // Updated path
  longDescription: [
    "Notre service de réseau informatique offre des solutions complètes pour la mise en place et la maintenance de votre infrastructure réseau. Nous concevons, installons et gérons des réseaux performants adaptés aux besoins spécifiques de votre entreprise.",
    "Nous utilisons les dernières technologies pour assurer la fiabilité et la sécurité de votre réseau, permettant une communication fluide et efficace au sein de votre organisation.",
  ],
  features: [
    "Installation et configuration de réseaux LAN/WAN",
    "Mise en place de solutions VPN sécurisées",
    "Configuration de pare-feu et équipements réseau",
    "Optimisation des performances réseau",
    "Surveillance et maintenance proactive",
    "Support technique 24/7",
  ],
  benefits: [
    "Amélioration de la productivité grâce à un réseau fiable",
    "Réduction des temps d'arrêt et des perturbations",
    "Protection renforcée contre les cybermenaces",
    "Évolutivité pour accompagner la croissance de votre entreprise",
    "Expertise technique de pointe",
  ],
};

const ReseauInformatique = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default ReseauInformatique;
